import { useState, useEffect } from 'react';
import { KeyCodes } from './KeyCodes';
/**
 * React hook to detect global keypress events
 * @param targetKey Array of keycode strings
 */
export default function useKeyPress(targetKey) {
    // State for keeping track of whether key is pressed
    const [keyPressed, setKeyPressed] = useState(false);
    // If pressed key is our target key then set to true
    function downHandler(e$) {
        const keyCode = KeyCodes[e$.code];
        if (targetKey.indexOf(keyCode) > -1) {
            setKeyPressed(true);
        }
    }
    // If released key is our target key then set to false
    const upHandler = (e$) => {
        const keyCode = KeyCodes[e$.code];
        if (targetKey.indexOf(keyCode) > -1) {
            setKeyPressed(false);
        }
    };
    // Add event listeners
    useEffect(() => {
        window.addEventListener('keydown', downHandler);
        window.addEventListener('keyup', upHandler);
        // Remove event listeners on cleanup
        return () => {
            window.removeEventListener('keydown', downHandler);
            window.removeEventListener('keyup', upHandler);
        };
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return keyPressed;
}
//# sourceMappingURL=useKeyPress.js.map